export const getInitials = (name) =>
  name && typeof name === 'string'
    ? name.trim().split(/\s+/).map((n) => n[0]).join('').substring(0, 2).toLocaleUpperCase('tr')
    : '?';

/**
 * Arama için metni sadeleştirir: Türkçe büyük/küçük harf (I/ı, İ/i) ve aksanlar (ç→c, ş→s, ğ→g, ö→o, ü→u)
 * eşitlenir, boşluklar tekleşir. "IŞIL", "ışıl" ve "isil" aynı sonucu verir.
 */
export const foldSearchText = (value) =>
  String(value ?? '')
    .toLocaleLowerCase('tr')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ı/g, 'i')
    .replace(/\s+/g, ' ')
    .trim();

/** Arama kutusu: ad/e-posta/telefon içinde geçen veya "#123456" biçimindeki öğrenci numarası */
export const matchesStudentSearch = (fields, term) => {
  const needle = foldSearchText(term).replace(/^#/, '');
  if (!needle) return true;
  return fields.some((field) => foldSearchText(field).includes(needle));
};

export const generateUserCode = () =>
  Math.floor(100000 + Math.random() * 900000).toString();

/**
 * [VERİ-3 DÜZELTMESİ] Yüzme süresi string'ini saniyeye çevirir.
 * Format: "MM:SS.cc" (örn. "00:25.40" veya "1:05.20")
 * Hatalı format için Infinity döner, bu sayede sıralamada en sona gider.
 */
export const parseSwimTime = (timeStr) => {
  if (!timeStr || typeof timeStr !== 'string') return Infinity;
  const match = timeStr.match(/^(\d+):(\d{2})\.(\d{2})$/);
  if (!match) return Infinity;
  return parseInt(match[1]) * 60 + parseInt(match[2]) + parseInt(match[3]) / 100;
};

/**
 * [VERİ-2 DÜZELTMESİ] Çakışmasız benzersiz ID üretir.
 * crypto.randomUUID önceliklidir, fallback olarak timestamp+random kullanılır.
 */
export const generateId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).substring(2, 11) + Date.now().toString(36);
};
